export const environment = {
  production: false,
  chatbotFeatureFlag: true,
  manualBlockTimeEntryFeatureFlag: true,
  layerSettings: {
    'boundary': { 
      filterByExtent: false 
    },
    'roads': {
      minScale: 30000,
      filterByExtent: true,
      popup: {
        includeFields: ['RoadId', 'Name', 'MaintOwner', 'CollectionAllowed']
      }
    }
  } as Record<string, { minScale?: number; filterByExtent?: boolean; popup?: { includeFields?: string[]; excludeFields?: string[] } }>,
  esri: {
    apiKey: 'AAPKfb21386f7ec0403f91e79c8ea0216881KYN7Sz3khZf2zspAxq8Hho06gYI_ZIxSHw3rlRGHyv-fapE73eb-uVHbigZa5riZ',
  },
  appShellConfig: {
    debug: false,
    networkDelay: 500,
  },
  applicationInsightsConnectionString: 'InstrumentationKey=6564bd2e-bb30-4ec1-bee0-2f807876dfe0;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=d76317db-880e-4e40-bc12-17df554dbada',
  legacyApiUrl: 'https://func-rt-dev-centralus-01.azurewebsites.net/api',
  authApiUrl: ( 
      process.env['NG_APP_AuthService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/auth'
  ) + "/api",
  activityApiUrl: (
      process.env['NG_APP_ActivityService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/activity'
  ) + "/api",
  auditApiUrl: (
      process.env['NG_APP_AuditService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/audit'
  ) + "/api",
  projectApiUrl: (
      process.env['NG_APP_ProjectService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/project'
  ) + "/api",
  userApiUrl: (
      process.env['NG_APP_UserService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/user'
  ) + "/api",
  lookupApiUrl: (
      process.env['NG_APP_LookupService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/lookup'
  ) + "/api",
  timeRecordApiUrl: (
      process.env['NG_APP_TimeRecordService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/timerecord'
  ) + "/api",
  timeApiUrl: (
      process.env['NG_APP_TimeService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/time'
  ) + "/api",
  mobileApiUrl: (
      process.env['NG_APP_MobileService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/mobile'
  ) + "/api",
  attachmentApiUrl: ( 
      process.env['NG_APP_AttachmentService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/attachment'
  ) + "/api",
  rolesApiUrl: (
      process.env['NG_APP_RoleService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/role'
  ) + "/api",
  flexFormsApiUrl: (
      process.env['NG_APP_FormService'] ??
      'https://apim-rtsvc-dev-centralus.azure-api.net/form'
  ) + "/api",
  notificationApiUrl: (
      process.env['NG_APP_NotificationService'] ??
      'https://app-rtsvc-notification-dev-centralus.azurewebsites.net'
  ) + "/api",
  webApiBaseUrl: (
    process.env['NG_APP_WebApi'] ??
    "https://app-rtsvc-webapi-dev-centralus.azurewebsites.net"
  ) + "/api",
  authApiKey: 'eEy1WT6vVV5PVlCVUc0wFhSnFuHfhDt8',
  apimSubscriptionKey: '918184f9b14e4855b4ec1ba6f9f94eaa',
  fakeGPS: {
    useFakeGPS: true,
    latitude: 40.714224,
    longitude: -73.961452,
  },
  version: '4.8.1',
  pollingTimeMs: 30000000,
  sharedFormQrCodeEncryptionKey: 'YDKGM',
  receiptQrCodeEncryptionKey: 'EJQDXPIU',
  defaultLoggingLevel: 4, // DEBUG
};

